<svelte:options accessors/>
<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {getCodModeloTasa, getFormatter, getSelectedCity} from "../../utils";
    import {Cart, getCart} from "../../models/cart";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import type {IPartResponse, IServiceResponse} from "../../data";
    import type {IPriceResponse} from "../../interfaces";
    import {ManagerVehicles} from "../../models/manager-vehicles";
    import NauiCheckbox from "../../naui/atoms/NauiCheckbox.svelte";


    export let price: IPriceResponse;
    export let part: IPartResponse;
    export let loading: boolean = true;
    export let cart: Cart;
    export let price_payload: any;
    let incluyeInstalacion: boolean = false;
    let tieneInstalacion: boolean = false;
    let service_price_payload: any;
    let service: IServiceResponse;

    let selectedVehicle;
    let codModeloTasa;

    const formatter = getFormatter();

    const dispatch = createEventDispatcher();

    const urlAsesoria = "https://api.whatsapp.com/send?phone=573022630685&text=Quisiera%20recibir%20asesor%C3%ADa%20sobre%20un%20repuesto%20en%20la%20tienda%20en%20l%C3%ADnea%20" + window.location.href;

    export let dialog: any = {
        open: false,
        message: ''
    }

    onMount(async () => {
        codModeloTasa = getCodModeloTasa(part);
        getCart().then(c => {
            cart = c;
        });
        const manager = ManagerVehicles.getInstance();
        manager.selected$.subscribe((next) => {
            selectedVehicle = next;
            tieneInstalacion = selectedVehicle?.isOrder;
            incluyeInstalacion = selectedVehicle?.isOrder;
        })
        await checkInstallation();
        await queryPrice();
    });

    async function checkInstallation() {
        const url = new URL('/backend/servicio/search-repuestos-in-servicios/', location.origin);
        url.search = new URLSearchParams({
            cod_referencia: part.cod_referencia
        }).toString();
        fetch(url.toString(), {
            method: 'GET'
        }).then(r => r.json()).then((response) => {
            if (Object.keys(response).length > 0) {
                service_price_payload = {
                    "ciudad": price_payload.ciudad,
                    "codReferencia": response.servicios[0].cod_referencia,
                    "incluyeInstalacion": 1,
                    "modeloTasa": codModeloTasa,
                    "tipo": response.servicios[0].tipo_dinissan,
                }
                service = response.servicios[0];
                tieneInstalacion = true;
            }
        }).catch((error) => {
            console.error(error);
        });
    }

    async function queryPrice(update: boolean = false) {
        if (price_payload) {
            loading = true;
            const url = new URL('/backend/servicio/precio-disponibilidad/', location.origin);
            if (incluyeInstalacion) {
                url.search = new URLSearchParams(service_price_payload).toString();
            } else {
                url.search = new URLSearchParams(price_payload).toString();
            }
            fetch(url.toString(), {
                method: 'GET'
            }).then(r => r.json()).then((response) => {
                price = response.prices[0];
                if (!price) {
                    throw new Error('No se encontró precio')
                } else {
                    loading = false;
                }
            }).catch((error) => {
                if (!update) {
                    loading = true;
                    incluyeInstalacion = true;
                    url.search = new URLSearchParams(service_price_payload).toString();
                    fetch(url.toString(), {
                        method: 'GET'
                    }).then(r => r.json()).then((response) => {
                        price = response.prices[0];
                        if (!price) {
                            throw new Error('No se encontró precio')
                        } else {
                            loading = false;
                        }
                    }).catch((error) => {
                        console.error('error en la consulta de precio', error)
                        price = null;
                        loading = false;
                    })
                } else {
                    console.error('error en la consulta de precio', error)
                    price = null;
                    loading = false;
                }
            });
        }
        return null
    }

    function add() {
        if (cart) {
            const selectedCity = getSelectedCity();
            const path = ['', 'repuesto', part?.slug]
            if (incluyeInstalacion) {
                cart.addService({
                    item: {
                        id: service.pk,
                        name: service.nombre,
                        reference: service.cod_referencia,
                        type: service.tipo_dinissan,
                        codModeloTasa: codModeloTasa,
                        image: service.images?.length > 0 ? service.images[0].image : '',
                        vin: selectedVehicle?.vin ?? '',
                        route: ['', 'servicio', service.slug].join('/')
                    },
                    prevPrice: price.precio_total,
                    price: price.precioNeto,
                    flag: price?.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                    quantity: 1,
                    city: {
                        id: selectedCity
                    }
                });
            } else {
                cart.addPart({
                    price: price.precioNeto,
                    prevPrice: price.precio_total,
                    flag: price?.porcDescuento > 0 ? `DCTO ${price.porcDescuento}% ` : '',
                    tiempoDespacho: price.tiempoDespacho,
                    quantity: 1,
                    disponibilidad: price.disponibilidad ? 1 : 0,
                    item: {
                        id: part.pk,
                        type: 'R',
                        image: part.images?.length > 0 ? part.images[0].image : '',
                        name: part.nombre,
                        reference: part.cod_referencia,
                        delivery: true,
                        codModelo: codModeloTasa,
                        route: path.join('/')
                    },
                    city: {
                        id: selectedCity
                    }
                });
            }
            cart.update().then(() => {
                dialog.open = true;
                dialog.message = 'El repuesto ha sido agregado al carrito';
            }).catch(() => {
                dialog.open = true;
                dialog.message = 'Se presento un error agregando el repuesto al carrito';
            });
        }
    }

    function closeDialog() {
        dialog.open = false;
        dialog.message = '';
    }
</script>
<div class="text-c mb-1 m:text-l m:mt-2">
    {#if tieneInstalacion}
        <div>
            <NauiCheckbox label="Lleva tu repuesto instalado por expertos"
                          bind:value={incluyeInstalacion}
                          on:change={() => queryPrice(true)}
            />
        </div>
    {/if}
    {#if loading}
        Consultando precio...
    {:else if price}
        {#if price.porcDescuento}
            <small>Antes {formatter(price.precio_total)}</small>
        {/if}
        <div class="price">
            {formatter(price.precioNeto)}
        </div>
        <div class="flex">
            <div class="btn accent mr-1" on:click={()=>add()}>
                AGREGAR
            </div>
            <a class="btn" href="{urlAsesoria}" target="_blank">
                RECIBIR ASESORÍA
            </a>
        </div>
    {:else}
        NO DISPONIBLE
    {/if}
</div>

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {dialog.message}
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>